// Dev-only preview routes that render without Clerk so the design can be
// driven in a browser before auth is wired. Mirrors the consumer pattern.
const DEV_PREVIEW_ROUTES = ["/preview/"] as const;

export function getBrowserPathname(): string {
  if (typeof window === "undefined") {
    return "/";
  }

  try {
    const pathname = window.location?.pathname;
    return typeof pathname === "string" && pathname.length > 0 ? pathname : "/";
  } catch {
    return "/";
  }
}

export function isDevPreviewPath(pathname: unknown): boolean {
  if (!import.meta.env.DEV) {
    return false;
  }

  if (typeof pathname !== "string") {
    return false;
  }

  return DEV_PREVIEW_ROUTES.some((route) => pathname.startsWith(route));
}
